// extracted by mini-css-extract-plugin
export default {"header":"xpMnMrLb","mobile":"mobile","fullwidth":"GBv6UyoQ","headerLeft":"C7fVbxOY","promo":"_fF5ioNm","controls":"WionMMga","overlay":"ikMT0Tv7"};